import React, { Fragment, FunctionComponent, useCallback, useEffect } from "react";
import styles from "./MenuOverlay.module.scss";

import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import { Helmet } from "react-helmet-async";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useWindowDimensions from "hooks/useWindowDimensions";

const MenuOverlay: FunctionComponent<any> = (props) => {
    const { width } = useWindowDimensions();

    const imageAspectRatio = getImageAspectRatio(undefined, props.header?.overlayLogo?.umbracoWidth, props.header?.overlayLogo?.umbracoHeight);

    const onEscKeyInput = useCallback((event) => {
        if (event.keyCode === 27) {
            props.dispatch({
                type: CLOSE_ALL_OVERLAYS
            });
        }
    }, []);

    const onCloseButtonClick = useCallback((event) => {
        props.dispatch({
            type: CLOSE_ALL_OVERLAYS
        });
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", onEscKeyInput, false);

        return () => {
            document.removeEventListener("keydown", onEscKeyInput, false);
        };
    }, []);

    return (
        <Fragment>
            {/* Lock the scrollbar for the rest of the page on mobile, while drawer is open */}
            {/* TODO: Remember the scroll position and restore it when toggling locked state */}
            {width <= 570 ? <Helmet bodyAttributes={{ class: "is-locked" }} /> : null}

            <nav className={styles.wrapper}>
                <div className={styles.inner}>
                    <div className={styles.header}>
                        {props.header?.overlayLogo ? (
                            <ImageViewer className={styles.logo} src={props.header.overlayLogo.umbracoFile.src} extensionType="png" type="containY" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                        ) : null}

                        <button className={styles.menu_close_button} onClick={(event) => onCloseButtonClick(event)}>
                            <span></span>
                            <span></span>
                        </button>
                    </div>

                    {props.menu ? (
                        <div className={styles.links}>
                            {props.menu?.map((level1Item: any, index: number) => {
                                return (
                                    <Anchor key={index} className={styles.link} to={level1Item.content.link}>
                                        <span className={styles.link_label}>{level1Item.content.label}</span>
                                    </Anchor>
                                );
                            })}
                        </div>
                    ) : null}
                </div>
            </nav>
        </Fragment>
    );
};

export default MenuOverlay;